import { Language } from '@wix/thunderbolt-becky-types'
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import {
	CarmiInstance,
	ICurrentLanguageAPI,
	MultilingualSiteConfig,
	SiteFeatureConfigSymbol,
} from '@wix/thunderbolt-symbols'
import type { DSCarmi } from 'thunderbolt-ds-carmi-root'
import { name } from '../symbols'

const currentLanguageFactory = (
	config: MultilingualSiteConfig,
	{ rendererModel, language, $runInBatch }: DSCarmi
): ICurrentLanguageAPI => {
	return {
		get: () => {
			return config.currentLanguage
		},
		set: (languageCode: Language) => {
			$runInBatch(() => {
				rendererModel.updateCurrentLanguageCode(languageCode)
				rendererModel.updateMultilingualInfoCurrentLanguage(languageCode) // todo @nitzan-remove after deprecating rendererModel.multilingualInfo - https://jira.wixpress.com/browse/TB-3553
				language.setLanguage(languageCode)
			})
		},
	}
}

export const DSCurrentLanguage = withDependencies(
	[named(SiteFeatureConfigSymbol, name), CarmiInstance],
	currentLanguageFactory
)
